export class MessageDto {
    public user: string = 'fcc5424b-636e-4e40-9cad-19fc5ca206b8';
    public msgText: string = '';
}